import type { AppEnvironment } from './types';
import { env as ip4xEnv } from './ip4x';

/**
 * IP4X staging (IP4X-Staging, deploy/staging/README.md): the production `ip4x` member app pointed
 * at staging's own core and region. Served from `dist/ip4x-staging` at `*.app.staging.ip4x.systems`;
 * each host resolves to its own tenant via Core, which needs `app.staging.ip4x.systems` in
 * BASE_DOMAINS.
 */
export const env: AppEnvironment = {
  ...ip4xEnv,
  buildMode: 'ip4x-staging',
  apiBaseUrl: 'https://api.staging.ip4x.systems/v1',
  coreApiUrl: 'https://core-api.staging.ip4x.systems/v1',
  portalBaseUrl: 'https://app.staging.ip4x.systems',
};
